<template>
  <N2PaginaBlog v-if="disenoPropio" />
  <div v-else>
    <!-- Start Breadcrump Area  -->
    <SliderBannerNotinTwo :obj="NOTARIA.Theme.Blog" type="blog" />
    <!-- End Breadcrump Area  -->

    <!-- Start blog Area  -->
    <div class="rn-blog-area rn-section-gap bg_color--1">
      <v-container>
        <!-- <v-row>
          <v-col cols="12">
            <div class="section-title section-title--2 text-center">
              <h2 class="heading-title">Latest News</h2>
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration.
              </p>
            </div>
          </v-col>
        </v-row> -->
        <!-- End .row -->
        <BlogNotinList :Home="false" type="blog"/>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
// Plantillas 2 a 5: la página con el diseño de su portada (refs: https://trello.com/c/3g3PTnq5, https://trello.com/c/MGgrmuPY, https://trello.com/c/XU15s9gl, https://trello.com/c/0Ma2vfxV)
import N2PaginaBlog from '../components/notaria2/N2PaginaBlog.vue'
import { useDisenoPropio } from '../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { useStore } from '../store/index'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const PageName="Blog"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
</script>
<style lang="css">
</style>
